import calls from '@/backend/api-calls'

const state = () => ({
  warehouseItems: [],
  selected: [],
  allSelected: false,
  loading: false,
  pagination: {
    page: 1,
    pages: 1
  },
  filters: {
  }
})

// getters
const getters = {
  ids: state => {
    return state.warehouseItems.map(d => d.id);
  }
}

// actions
const actions = {
  getWarehouseItems: ({commit}, parameters) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.warehouseItems.get(parameters)
        .then(resp => {
          commit("setWarehouseItems", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  addWarehouseItem({commit}, { data, parameters }) {
    return new Promise((resolve, reject) => {
      calls.warehouseItems.post(data, parameters)
        .then(resp => {
          commit("insertWarehouseItem", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Warehouse item successfully added'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateWarehouseItem: ({commit}, { warehouseItemId, data }) => {
    return new Promise((resolve, reject) => {
      calls.workstation.put(warehouseItemId, data).then(
        resp => {
          commit("insertUpdatedWarehouseItem", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Warehouse item successfully updated'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteWarehouseItem: ({commit}, warehouseItemId) => {
    return new Promise((resolve, reject) => {
      calls.workstations.delete(warehouseItemId).then(
        resp => {
          commit("removeWarehouseItem", warehouseItemId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Warehouse item successfully deleted'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.ids);
    } else {
      commit("deselectAll");
    }
  }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setWarehouseItems(state, data) {
    state.pagination = data.pagination;
    state.warehouseItems = data.results;
  },
  insertWarehouseItem(state, data) {
    state.warehouseItems.push(data);
  },
  insertUpdatedWarehouseItem(state, data) {
    state.warehouseItems.forEach((warehouseItem, i) => {
      if (warehouseItem.id == data.id) {
        state.warehouseItems.splice(i, 1, data);
      }
    })
  },
  removeWarehouseItem(state, warehouseItemId) {
    state.warehouseItems.forEach((warehouseItem, i) => {
      if (warehouseItem.id == warehouseItemId) {
        state.warehouseItems.splice(i, 1);
      }
      const index = state.selected.indexOf(warehouseItemId);
      if (index != -1) {
        state.selected.splice(index, 1);
      }
    })
  },
  changePage(state, page) {
    state.pagination.page = page;
  },
  selectAll(state, ids) {
    state.allSelected = true;
    ids.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}